import { Component, OnInit } from '@angular/core';

import { PageEvent } from '@angular/material';
import { Router } from '@angular/router';
import { CollegeService } from '../services/College_name.service';
import * as moment from 'moment';


type CollegeDetails={
  College_Name:string,
  College_Id: number,
  Start_Date: string,
  Year: number,
  Question_Set:number
}

@Component({
 
  templateUrl: './completed-college.component.html',
  styleUrls: ['./completed-college.component.scss']
})

export class CompletedCollegeComponent implements OnInit {


  college:CollegeDetails[]=[];
  count:number;

 
  

  itemsPerPage = 6;
  currentPage = 1;

  totalPages: number;
  pagedCards: any[];
  pageSize = 6;
  pageSizeOptions: number[] = [3, 6,9];

  lname: string;
  fname: string;
  user: string;
  userAdmin: boolean;
  userEvaluator: boolean;
  userTestScheduler: boolean;
  OutputArrayNew: any[];
  endDate: Date;
  startDate: Date;
  OutputArraylastFiltered: any[];
  last7daysCards: any[];



  constructor(private collegeservice:CollegeService,private router: Router ) { }

  ngOnInit() {
    this.getAccess();
    this.displayCardDetails();

    //this.onlyDisplayLast14DaysRecords();
    // this.updatePaginatedData();
    
    
    
  }

  getAccess(){
   
    this.user = sessionStorage.getItem('user');
    this.fname = sessionStorage.getItem('fname');

    this.lname = sessionStorage.getItem('lname');

   
    if (this.user === '1') {
      this.userAdmin = true;
      this.userTestScheduler = false;
      this.userEvaluator = false;
    } else if (this.user === '2') {
     
      this.userEvaluator = true;
      this.userAdmin = false;
      this.userTestScheduler = false;
    } else if (this.user === '3') {
     
      this.userTestScheduler = true;
      this.userAdmin = false;
      this.userEvaluator = false;  
    }
  }

  displayCardDetails(){

   var moment=require("moment")


    this.collegeservice.get_schedule_details().subscribe(
      (data) => {

        

        this.college= data.results;
        

       
        for(var i=0;i<this.college.length;i++){
        
    
          var trimmeddate = this.college[i].Start_Date; 
          var newDate = moment(trimmeddate).format('YYYY/MM/DD')

          this.college[i].Start_Date = newDate;

          
        }
    
        this.onlyDisplayLast7DaysRecords(this.college)
        // this.pagedCards=this.college.slice(0,this.itemsPerPage)
      


     

       this.totalPages = this.getTotalPages();
        
  
      },
      err => {
        console.error(err);
      }
    );


  }


  updatePage(pageIndex: number, pageSize: number,arr:any[]) {
    
    const startIndex = pageIndex * pageSize;
    const endIndex = startIndex + pageSize;
    this.pagedCards = arr.slice(startIndex, endIndex);
   
  }

  onPageChange(event: PageEvent,arr:any[]) {
  
    
    const { pageIndex, pageSize } = event;
    
    this.updatePage(pageIndex, pageSize,arr);
  }


 

//need work here
  openStudentDetailBench(record){
 
    const params = { Question_Set_Id: record.Question_Set_Id,College_Id:record.College_Id,Year_Id:record.Year,Total_Students:record.Total_Students};
    
    this.router.navigate(['/student_details_workbench',params])

  }

  
  

  // Correct
getTotalPages() {
  
  return Math.ceil(this.college.length / this.itemsPerPage);
}




previousPage() {
  if (this.currentPage > 1) {
    this.currentPage--;
  }
}

nextPage() {
  if (this.currentPage < this.totalPages) {
    this.currentPage++;
  }
}

async onlyDisplayLast7DaysRecords(inputArray){
  // this.dateFilteredScreen= true;
 // this.defaultScreen = false;
 // this.dateFilteredScreen = false;
  this.OutputArrayNew = [];
  this.OutputArraylastFiltered=[];
  this.endDate = new Date();
  this.startDate = new Date();
  this.startDate.setDate(this.endDate.getDate() - 7);


  var startDateFormatted = moment(this.startDate).format('YYYY/MM/DD');
  var endDateFormatted = moment(this.endDate).format('YYYY/MM/DD');

  

  
  for(var i=0;i<inputArray.length;i++){
    this.OutputArraylastFiltered[i] =  inputArray[i];
  }

  

  for(var i=0;i<this.OutputArraylastFiltered.length;i++){

    //moment(this.ScheduleDetailsFromDb[i].Start_Date).format('YYYY-MM-DD');
    if(this.OutputArraylastFiltered[i].Start_Date >= startDateFormatted && this.OutputArraylastFiltered[i].Start_Date <= endDateFormatted){
    
     // moment(this.ScheduleDetailsFromDb[i].Start_Date).format('DD/MM/YYYY');
      this.OutputArrayNew.push(this.OutputArraylastFiltered[i]);
    }

  }


 




this.last7daysCards= [];
this.last7daysCards= this.OutputArrayNew;

this.updatePage(0, this.pageSize,this.last7daysCards);
//  return this.OutputArrayNew;
return this.pagedCards;


}

  
  

}